import { createSelector } from 'redux-orm';
import orm from '%paysera_seat_selection/js/seatSelection/redux/model';
import dbSelector
    from '%paysera_seat_selection/js/seatSelection/redux/component/orm/selectors/dbSelector';

export default createSelector(
    orm,
    dbSelector,
    (state, id) => id,
    ({ GeneralAdmission }, id) => {
        const generalAdmission = GeneralAdmission.withId(id);
        if (!generalAdmission) {
            return null;
        }

        return generalAdmission.ticketType;
    },
);
